import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Filter, Search } from 'lucide-react';
import { ProgressBar } from '../components/ProgressBar';
/**
 * Static "Sample" snapshot of the Journal Feed design.
 * Uses fixed mocked data — does not respond to settings or daily state.
 */
export function Sample() {
  const navigate = useNavigate();
  const recentDays = [{
    date: 'Oct 23',
    hp: '85%',
    pp: '70%',
    summary: '3 Wins • Low energy in afternoon → Schedule deep work before 10am',
    streak: 5
  }, {
    date: 'Oct 22',
    hp: '90%',
    pp: '80%',
    summary: 'Strong focus blocks • Evening yoga helped sleep → Maintain hydration',
    streak: 4
  }, {
    date: 'Oct 21',
    hp: '100%',
    pp: '100%',
    summary: 'All metrics hit • Productive morning • → Keep this rhythm',
    streak: 3
  }];
  return <div className="max-w-5xl mx-auto p-8" data-id="element-216">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-217">
        {/* Left Column */}
        <div className="lg:col-span-7 space-y-10" data-id="element-218">
          <div data-id="element-219">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-220">
              Good Morning, Alex
            </h1>
            <p className="text-gray-500 mt-1" data-id="element-221">Thursday, May 14</p>
          </div>

          <div className="space-y-6" data-id="element-222">
            <ProgressBar label="HP — Habit Progress" value="4/6 habits done" percentage={67} colorClass="bg-emerald-500" data-id="element-223" />
            <ProgressBar label="PP — Project Progress" value="1h 45m / 2h" percentage={87} colorClass="bg-indigo-500" data-id="element-224" />
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-225">
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-226">
              Yesterday's Reflection / Today's Improvement:
            </h3>
            <p className="text-gray-800 text-lg font-medium leading-relaxed" data-id="element-227">
              "5-minute tea break when stressed instead of doomscrolling"
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-228">
            <button onClick={() => navigate('/log')} className="px-8 py-3.5 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-xl shadow-sm transition-colors" data-id="element-229">
              Log Progress
            </button>
            <button onClick={() => navigate('/reflection')} className="px-8 py-3.5 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-xl shadow-sm transition-colors" data-id="element-230">
              Log Reflection
            </button>
          </div>
        </div>

        {/* Right Column */}
        <div className="lg:col-span-5 space-y-6" data-id="element-231">
          <div className="flex items-center justify-between mb-4" data-id="element-232">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-233">
              Recent GPS Days
            </h2>
            <button className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-234">
              <Filter className="w-5 h-5" data-id="element-235" />
            </button>
          </div>

          <div className="space-y-4" data-id="element-236">
            {recentDays.map((day, idx) => <div key={idx} className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer" data-id="element-237">
                <div className="flex justify-between items-center mb-3" data-id="element-238">
                  <span className="font-semibold text-gray-900" data-id="element-239">
                    {day.date}
                  </span>
                  <div className="text-xs font-medium text-gray-500 flex gap-3" data-id="element-240">
                    <span data-id="element-241">HP {day.hp}</span>
                    <span data-id="element-242">PP {day.pp}</span>
                  </div>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed mb-4" data-id="element-243">
                  {day.summary}
                </p>
                <div className="flex justify-end" data-id="element-244">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-orange-50 text-orange-700 text-xs font-medium border border-orange-100" data-id="element-245">
                    🔥 {day.streak} day streak
                  </span>
                </div>
              </div>)}
          </div>

          <div className="relative mt-8" data-id="element-246">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-247">
              <Search className="h-4 w-4 text-gray-400" data-id="element-248" />
            </div>
            <input type="text" className="block w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm" placeholder="Search your thoughts..." data-id="element-249" />
          </div>
        </div>
      </div>
    </div>;
}